import React, { Component } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";

import CloneICON from "../../../assets/images/clone.svg";
import "./Line.scss";
import LineModal from "./LineModal";

class Line extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editLine: false,
    };
  }
  componentDidMount = () => {
    this.getTimerVal;
  };
  hideLineSetting = () => {
    this.setState({ editLine: !this.state.editLine });
  };
  render() {
    return (
      <div
        style={{
          paddingTop:
            this.props.marginTop +
            (this.props.lineMarginUnit ? this.props.lineMarginUnit : "px"),
          paddingRight:
            this.props.marginRight +
            (this.props.lineMarginUnit ? this.props.lineMarginUnit : "px"),
          paddingBottom:
            this.props.marginBottom +
            (this.props.lineMarginUnit ? this.props.lineMarginUnit : "px"),
          paddingLeft:
            this.props.marginLeft +
            (this.props.lineMarginUnit ? this.props.lineMarginUnit : "px"),
        }}
        className={
          "line-wrapper " +
          (this.props.element.dataModule ? " hideDragHandle" : " ")
        }
      >
        <div className="actionControl">
          <span
            onClick={() => this.setState({ editLine: !this.state.editLine })}
            className="image-setting"
          >
            Line Settings
          </span>
          <button className="clone-item" onClick={() => { this.props.cloneElement(this.props.element.id) }}>
            <img src={CloneICON} />
          </button>
          <span className="delete-item" onClick={() => { this.props.deleteElement(this.props.element.id) }}>
            <i className="far fa-trash-alt" />
          </span>
        </div>

        <div
          style={{
            width: "100%",
            height: this.props.borderWidth + "px",

            backgroundColor:
              typeof this.props.backgroundColor == "string"
                ? this.props.backgroundColor
                : `rgba(
                      ${this.props.backgroundColor.r},
                      ${this.props.backgroundColor.g},
                      ${this.props.backgroundColor.b},
                      ${this.props.backgroundColor.a}
                    )`,
          }}
        />
        {this.state.editLine && (
          <LineModal
            borderWidth={this.props.borderWidth}
            lineMarginUnit={this.props.lineMarginUnit}
            marginBottom={this.props.marginBottom}
            marginTop={this.props.marginTop}
            backgroundColor={this.props.backgroundColor}
            label={this.props.label}
            hideLineSetting={this.hideLineSetting}
            ID={this.props.ID}
            preset={this.props.preset}
          />
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutTitle: state.present.layoutTitle,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Line);
